import { put, call, takeLatest, select, all } from "redux-saga/effects";
import  * as ToDoApi from "../../Diaries/api";
import * as ActionConstants from "./actions/actionConstants";
import { LOG_APPLICATON_ERROR, RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS, WORKKARD_TODO_OWNERS_REQUEST, FETCH_MIDDLE_PANEL_DATA_REQUEST, BUTTON_LOADER } from "../../..//containers/WorkkardDetail/actions/actionConstants";
import { logout } from '../../WorkkardDetail/Saga/common';
import { ErrorCode, PAGE_SIZE } from '../../..//containers/WorkkardDetail/constants';
import {
    GET_DIARY_DETAIL_REQUEST, UPDATE_DIARY_LIST_SUCCESS, UPDATE_DIARY_VIEW_SUCCESS, GET_TODO_WEEK_DATA, GET_DIARIES_LIST_DATA, GET_DIARY_LOGS,
    GET_TODO_MONTH_DATA, GET_TODO_LIST_DATA_SUCCESS, GET_DIARY_LOGS_SUCCESS,
    CREATE_DIARY_REQUEST, UPDATE_DIARY_REQUEST,
    FETCH_DIARY_TAGS,FETCH_DIARY_TAGS_SUCCESS,
} from "../../Diaries/actions/actionConstants";
import { DEFAULT_TIME_FORMAT } from '../../../common/constants';
import moment from 'moment';
const hourFormat = "hh A";
import * as PUBLIC_API_DIARY_ACTION from "../../../publicApiActions/diaryActions";
import { HIDE_TOAST, SHOW_TOAST_WITH_PROPS } from '../../../common/actionConstants';
import * as CommonUtil from '../../../common/util';

export function* fetchDiaryTags() {
    try {
        yield put({ type: ActionConstants.SHOW_DIARY_FORM_LOADER });
        const response = yield call(ToDoApi.fetchDiaryTags, FETCH_DIARY_TAGS);
        const tagList = response?.Diaries?.Tags?.tags ?? []
        if (tagList?.length > 0) {
            yield put({
                type: FETCH_DIARY_TAGS_SUCCESS,
                payload: {
                    tags: tagList.map(item => ({
                        id: item.tag,
                        text: item.tag,
                    })),
                },
            });
        }
    }
    catch (error) {
        console.error("Error in fetchDiaryTags saga", error);
    }
    finally {
        yield put({ type: ActionConstants.HIDE_DIARY_FORM_LOADER });
    }
}

export function* createDiary(action) {
    yield put({ type: BUTTON_LOADER, payload: { createDiary: true } });

    try {
        const { callback, referrer, ModuleId, Module, ...data } = action.payload;

        const todoPayload = {
            data,
            moduleId: ModuleId,
            module:   Module,
        };

        const createResponse = yield call(ToDoApi.createToDo, CREATE_DIARY_REQUEST, todoPayload);

        // Runs if createResponse geting Error
        if (createResponse.status === ErrorCode.RedirectToLogout) {
            yield* logout();
            return;
        }

        if (createResponse.status === ErrorCode.Fail && createResponse.toastPayload) {
            yield put({ type: SHOW_TOAST_WITH_PROPS, payload: createResponse.toastPayload });
            callback();
            return;
        }

        if (!createResponse.status) {
            yield put({ type: LOG_APPLICATON_ERROR, payload: { status: createResponse.status, isErrorScreen: false } });
            return;
        }

        // Runs if createResponse.status is true
        if (createResponse.status) {
            const listPayload = { page_size: PAGE_SIZE, page_no: 1 };
            const listResponse = yield call(ToDoApi.getToDoList, GET_DIARIES_LIST_DATA, listPayload);
            yield put({ type: SHOW_TOAST_WITH_PROPS, payload: "Diary created successfully" });
            yield put({
                type: GET_TODO_LIST_DATA_SUCCESS,
                payload: {
                    ...listResponse,
                    Data: listResponse?.Diaries?.Details?.diaries ?? [],
                },
            });
            yield put({ type: HIDE_TOAST });
            callback();
        }
    } catch (error) {
        console.error("CRITICAL SAGA ERROR:", error);
    } finally {
        yield put({ type: BUTTON_LOADER, payload: { createDiary: false } });
    }
}

// export function* fetchDiariesByDate(action) {
//     try {
//         yield put({ type: ActionConstants.SHOW_DIARY_FORM_LOADER });
//         const response = yield call(Api.fetchDiariesByDate, ActionConstants.FETCH_DIARIES_BY_DATE, action.payload);
//         if (response.status == 200) {
//             yield put({
//                 type: ActionConstants.FETCH_DIARIES_BY_DATE_SUCCESS,
//                 payload: {
//                     diariesByDate: response.data.TodoDayViewResponseData
//                 }
//             })
//         }
//         else if (response.status == ErrorCode.RedirectToLogout) {
//             yield* logout();
//         } else {
//             yield put({
//                 type: LOG_APPLICATON_ERROR,
//                 payload: { status: response.status, isErrorScreen: false }
//             });
//         }
//     }
//     catch (error) {
//         console.log(error);
//     }
//     finally {
//         yield put({ type: ActionConstants.HIDE_DIARY_FORM_LOADER });
//     }
// }

// export function* fetchEditDiaryData(action) {
//     try {
//         yield put({ type: ActionConstants.SHOW_DIARY_FORM_LOADER });
//         const response = yield call(Api.fetchEditDiaryData, ActionConstants.EDIT_DIARY_REQUEST, action.payload);
//         if (response.status == 200) {
//             let teamMembers = response.Data.TeamMembers && response.Data.TeamMembers.map(user => ({
//                 UserId: user.Id,
//                 FirstName: user.FirstName,
//                 LastName: user.LastName,
//                 MiddleName: user.MiddleName,
//                 UserName: user.UserName,
//                 Email: user.Email,
//                 Title: user.Title,
//                 OrganizationId: user.OrganizationId,
//                 ProfileImage: user.ProfileImageUrl,
//                 ProfileImageForMob: user.ProfileImageUrl,
//                 IsActive: user.IsActive,
//                 DisplayName: user.DisplayName,
//             }));
//             const getTimezoneData = (state) => state.sessionContext.tzData;
//             const timeZoneData = yield select(getTimezoneData);
//             let tzData = timeZoneData.map(item => {
//                 return { label: item.DisplayText, value: item.UniversalTimeZoneId };
//             });
//             delete response.Data.TeamMembers;
//             yield put({
//                 type: ActionConstants.FETCH_CREATE_DIARY_DATA_SUCCESS,
//                 payload: {
//                     ownersList: teamMembers,
//                     formData: response.Data,
//                     userId: response.userId,
//                     canAddMoreDueDates: response.canAddMoreDueDates,
//                     timezoneData: tzData
//                 }
//             })
//         }
//         else if (response.status == ErrorCode.RedirectToLogout) {
//             yield* logout();
//         } else {
//             yield put({
//                 type: LOG_APPLICATON_ERROR,
//                 payload: { status: response.status, isErrorScreen: false }
//             });
//         }
//     }
//     catch (error) {
//         console.log(error);
//     }
//     finally {
//         yield put({ type: ActionConstants.HIDE_DIARY_FORM_LOADER });
//     }
// }

export function* updateDiary(action) {
    try {
        yield put({ type: BUTTON_LOADER, payload: { createDiary: true } });

        const { callback, referrer, ...payload} = action.payload;
        // console.log(action, referrer, '----------action');
        
        // delete action.payload.callback;
        // delete action.payload.referrer;


        // let todoDueDateISO = CommonUtil.convertDateTimeToISOString(action.payload.DateTime);

        // if (action.payload.Reminder != '') {
        //     var todoRemDateISO = CommonUtil.convertDateTimeToISOString(action.payload.Reminder);
        // }
        // let todoPayload = {
        //     data: {
        //         title: action.payload.TodoTitle,
        //         due_on_tz: action.payload.DueDateTz,
        //         due_on_iso: todoDueDateISO,
        //         comment: action.payload.DateChangeComment,
        //         description: action.payload.TodoDescription,
        //         // assignee_id: action.payload.assignMethodId, //Todo: this abbout assignid
        //         tags: JSON.parse(action.payload.tags),
        //         reminder_setting_iso: action.payload.Reminder == '' ? null : todoRemDateISO,
        //         reminder_setting_tz: action.payload.ReminderTz == '' ? null : action.payload.ReminderTz,
        //         priority: action.payload.Priotity == 1 ? 'Low' : action.payload.Priotity == 2 ? 'Normal' : 'High',
        //         attachments: action.payload.FnolFileGuid ? [{ guid: action.payload.FnolFileGuid?.split('.')[0], caption: action.payload.Caption }] : []
        //     },
        //     moduleId: action.payload.ModuleId,
        //     module: action.payload.Module,
        //     TodoId: action.payload.TodoId,
        // }
        
        // const response = yield call(ToDoApi.updateToDo, todoPayload);
        const response = yield call(ToDoApi.updateToDo, UPDATE_DIARY_REQUEST, payload);
        if(response.status) {
            if (referrer === "tdo") {
                let listResponse = yield call(ToDoApi.getToDoList, GET_DIARIES_LIST_DATA, payload);
                yield put({
                    type: UPDATE_DIARY_VIEW_SUCCESS, 
                    payload:{
                        ...listResponse
                    }});
            }
            callback();
        }
        
        // if (response.status == 200) {
        //     if (referrer === "getclmdetail") {
        //         // Refresh diaries if diaries tab is active

        //         const getWorkkardDetailData = (state) => state.workkardDetail;
        //         const workkardDetailData = yield select(getWorkkardDetailData);
        //         const diaries = workkardDetailData.middlePanel.diaries;

        //         if (workkardDetailData.middlePanel.activeTab === 2) {
        //             yield put({ type: RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS });
        //             const diaryPayload = {
        //                 cId: workkardDetailData.workkardDetail.Id,
        //                 type: diaries.type,
        //                 actId: workkardDetailData.activityDetail.ActivityId,
        //                 skip: 0,
        //                 take: 10,
        //                 sortBy: diaries.sortBy || "SortByDueDate",
        //                 sort: diaries.filter.sort || "OPEN",
        //                 rows: 10,
        //                 todoOwners: diaries.filter.todoOwners,
        //                 filterOption: JSON.stringify(Object.assign([], diaries.filter.filterOption, ["activity", "workkard"]))
        //             }
        //             yield put({ type: WORKKARD_TODO_OWNERS_REQUEST, payload: diaryPayload })
        //         } else {
        //             yield put({ type: FETCH_MIDDLE_PANEL_DATA_REQUEST, payload: { activeTab: 2 } });
        //         }
        //     }
        //     else if (referrer === "tdo") {
        //         const getDiariesData = (state) => state.diaries;diariesData
        //         const diariesData = yield select(getDiariesData);
        //         const view = diariesData.view.view;
        //         const listingFilter = diariesData.listing.filterOption;
        //         const listing = diariesData.listing;
        //         let payload = {
        //             startdate: diariesData.view.startdate,
        //             endDate: diariesData.view.endDate
        //         };
        //         if (view == 'list') {
        //             if (listing.activeTab == 1) {
        //                 const logsPayload = { id: listing.selectedDiary };
        //                 const logsResponse = yield call(ToDoApi.getDiaryLogs, GET_DIARY_LOGS, logsPayload);
        //                 if (logsResponse.status == 200)
        //                     yield put({ type: GET_DIARY_LOGS_SUCCESS, payload: logsResponse });
        //             }
        //             const payload = {
        //                 id: action.payload.TodoId,
        //                 tvw: 'list',
        //                 pr: listingFilter.priority == 'ALLP' ? '0' : listingFilter.priority,
        //                 st: listingFilter.status,
        //                 sh: listingFilter.searchKey
        //             }
        //             const response = yield call(ToDoApi.getDiaryDetail, GET_DIARY_DETAIL_REQUEST, payload);
        //             if (response.status == 200) {
        //                 yield put({ type: UPDATE_DIARY_LIST_SUCCESS, payload: response.Data });
        //             }
        //             else if (response.status == ErrorCode.RedirectToLogout) {
        //                 yield* logout();
        //             } else {
        //                 const payload = {
        //                     key: listingFilter.searchKey,
        //                     priority: listingFilter.priority,
        //                     status: listingFilter.status,
        //                     skip: 0,
        //                     take: 15,
        //                     isSearch: listingFilter.searchKey.trim().length ? true : false,
        //                     rows: 15,
        //                     _: + new Date()
        //                 }                        
        //                 let listResponse = yield call(ToDoApi.getToDoList, GET_DIARIES_LIST_DATA, payload);
        //                 yield put({ type: GET_TODO_LIST_DATA_SUCCESS, payload: { ...listResponse, filterOption: listingFilter } });

        //             }
        //         }
        //         else {
        //             let response, obj = {};;
        //             if (view == 'day') {
        //                 response = yield call(ToDoApi.getTodoWeekData, GET_TODO_WEEK_DATA, payload);
        //                 if (response.status == 200) {
        //                     response.data.TodoDayViewResponseData.forEach(d => {
        //                         if (obj.hasOwnProperty(d.Key.Day)) {
        //                             if (obj[d.Key.Day].hasOwnProperty(moment(d.Key.Time, hourFormat).format(hourFormat))) {
        //                                 obj[d.Key.Day][moment(d.Key.Time, hourFormat).format(hourFormat)].push(d.TodoData);
        //                             } else {
        //                                 obj[d.Key.Day][moment(d.Key.Time, hourFormat).format(hourFormat)] = [d.TodoData];
        //                             }

        //                         } else {
        //                             obj[d.Key.Day] = {}
        //                             obj[d.Key.Day][moment(d.Key.Time, hourFormat).format(hourFormat)] = [d.TodoData]
        //                         }
        //                     })
        //                 }
        //             }
        //             else {
        //                 response = yield call(ToDoApi.getTodoMonthData, GET_TODO_MONTH_DATA, payload);
        //                 if (response.status == 200) {
        //                     response.data.TodoDayViewResponseData.forEach(d => {
        //                         if (obj.hasOwnProperty(d.Day)) {
        //                             obj[d.Day].push(d.TodoData);
        //                         } else {
        //                             obj[d.Day] = d.TodoData
        //                         }
        //                     })
        //                 }
        //             }
        //             yield put({ type: UPDATE_DIARY_VIEW_SUCCESS, payload: { data: obj, date: moment(action.payload.DateTime).format(DEFAULT_TIME_FORMAT) } })
        //         }
        //         // else{
        //         //     yield put({type: UPDATE_DIARY_VIEW_SUCCESS, payload:{Title:action.payload.TodoTitle, Id: action.payload.TodoId, Priorty: action.payload.Priotity , date: action.payload.DateTime,key:action.payload.key}});
        //         // }
        //     }
        //     callback();
        // }
        // else if (response.status == ErrorCode.Fail && response.toastPayload) {
        //     yield put({ type: SHOW_TOAST_WITH_PROPS, payload: response.toastPayload });
        // }
        // else if (response.status == ErrorCode.RedirectToLogout) {
        //     yield* logout();
        // } else {
        //     yield put({
        //         type: LOG_APPLICATON_ERROR,
        //         payload: { status: response.status, isErrorScreen: false }
        //     });
        // }
    }
    catch (error) {
        console.error("Error in updateDiary saga", error);
    }
    finally {
        yield put({ type: BUTTON_LOADER, payload: { createDiary: false } });
    }
}

export default [
    takeLatest(FETCH_DIARY_TAGS, fetchDiaryTags),
    takeLatest(CREATE_DIARY_REQUEST, createDiary),
    // takeLatest(ActionConstants.FETCH_DIARIES_BY_DATE, fetchDiariesByDate),
    // takeLatest(ActionConstants.EDIT_DIARY_REQUEST, fetchEditDiaryData),
    takeLatest(UPDATE_DIARY_REQUEST, updateDiary),
];

